import { useEffect } from 'react';
import { observer } from 'mobx-react';

import { Flex } from '@servicetitan/anvil2';
import { BodyText } from '@servicetitan/design-system';
import { provide, useDependencies } from '@servicetitan/react-ioc';
import { CenteredSpinner } from '@servicetitan/marketing-ui';

import { LoadStatus } from '../../../common/enums/load-status';
import { TcrStore } from '../stores/tcr.store';
import { ManageTenantStore } from '../../stores/manage-tenant.store';
import { BrandSection } from './brand-section';

import * as Styles from './tcr.module.less';

export const Tcr = provide({
    singletons: [TcrStore],
})(
    observer(() => {
        const [{ brands, loadStatus, error, init }] = useDependencies(TcrStore);
        const [manageTenantStore] = useDependencies(ManageTenantStore);

        useEffect(() => {
            if (manageTenantStore.tenant) {
                init();
            }
        }, [manageTenantStore.tenant, init]);

        if (loadStatus === LoadStatus.Loading) {
            return <CenteredSpinner />;
        }

        if (loadStatus === LoadStatus.Error) {
            return (
                <div className={Styles.container}>
                    <BodyText>{error || 'Failed to load TCR data, please refresh'}</BodyText>
                </div>
            );
        }

        return (
            <div className={Styles.container}>
                <Flex direction="column" gap="6">
                    {brands.map((brand, index) => (
                        <BrandSection key={brand.id} brand={brand} brandIndex={index + 1} />
                    ))}

                    {brands.length === 0 && loadStatus === LoadStatus.Ok && (
                        <div className={Styles.emptyStatePadding}>
                            <Flex alignItems="center" justifyContent="center">
                                <BodyText color="neutral-400">
                                    No TCR brands found for this tenant.
                                </BodyText>
                            </Flex>
                        </div>
                    )}
                </Flex>
            </div>
        );
    }),
);
